// The same name comparison the server uses (backend/services/expenseCategories.js): keep the two in step, so what the
// screen calls "parecida" is what the server will ask to confirm.

// "Préstamos", "prestamos" and " PRÉSTAMOS. " are the same category.
export const keyFor = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

const stem = (word) => word.replace(/(es|s)$/, '');
const words = (key) => key.split(' ').filter(w => w.length >= 4).map(stem);

function distance(a, b) {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let prev = row[0];
    row[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const next = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = row[j];
      row[j] = next;
    }
  }
  return row[b.length];
}

// Two keys that are probably the same thing spelled differently: a typo, singular/plural, one inside the other, or a
// shared meaningful word.
export function isSimilar(a, b) {
  if (!a || !b) return false;
  if (stem(a) === stem(b)) return true;
  const shorter = Math.min(a.length, b.length);
  if (shorter >= 4 && (a.includes(b) || b.includes(a))) return true;
  if (distance(a, b) <= (shorter <= 7 ? 1 : 2)) return true;
  const wb = new Set(words(b));
  return words(a).some(w => wb.has(w));
}
